import { Component, forwardRef } from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  UntypedFormBuilder,
  UntypedFormGroup,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validator,
} from '@angular/forms';
import { RadioTagsState } from '@app/library/states/radio-tags.state';
import { Select } from '@ngxs/store';
import { slideInOutBlock } from '@radioking/ui/animations';
import { SugestionInput } from '@radioking/ui/input';
import { Observable } from 'rxjs';

@Component({
  selector: 'rk-filter-tag-input',
  templateUrl: './filter-tag-input.component.html',
  styleUrls: ['./filter-tag-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FilterTagInputComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => FilterTagInputComponent),
      multi: true,
    },
  ],
  animations: [slideInOutBlock],
})
export class FilterTagInputComponent implements ControlValueAccessor, Validator {
  @Select(RadioTagsState.tagsFormatted)
  tags$: Observable<SugestionInput[]>;

  tagsForm: UntypedFormGroup;

  constructor(private readonly fb: UntypedFormBuilder) {
    this.tagsForm = this.fb.group({
      operator: 'not_set',
      value: [[]],
    });
  }

  onTouched: () => void = () => {};

  writeValue(val: any): void {
    if (!val) {
      return;
    }
    this.tagsForm.setValue(val, { emitEvent: false });
  }

  registerOnChange(fn: any): void {
    this.tagsForm.valueChanges.subscribe(fn);
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.tagsForm.disable() : this.tagsForm.enable();
  }

  validate(_: AbstractControl): ValidationErrors | null {
    return this.tagsForm.valid
      ? null
      : { invalidForm: { valid: false, message: 'TAGS' } };
  }
}
